import {decodeRot13} from "@/core/utils/helpers/textHelpers";

/**
 * Generates a unique impression ID for native ad tracking
 * Format: timestamp-randomString (e.g., "1730000000000-abc123xyz")
 * @returns {string}
 */
export function generateImpressionId() {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 11);

    return `${timestamp}-${randomString}`;
}

/**
 * Debug helper to decode and log advert tracking URL parameters
 * Decodes base64 encoded URL, extracts and ROT13 decodes the 'to' parameter,
 * and displays all query parameters in a console table
 *
 * @param {string} encodedClickUrl - Base64 encoded tracking URL
 * @param {string} [label='Advert'] - Label to identify the advert type in logs
 */
export function logDecodedAdvertUrl(encodedClickUrl, label = 'Advert') {
    if (!encodedClickUrl) {
        return;
    }

    try {
        // Decode base64 URL
        const decodedUrl = atob(encodedClickUrl);
        console.log(`${label} URL (decoded):`, decodedUrl);

        // Extract and decode the 'to' parameter
        const url = new URL(decodedUrl);
        const toParam = url.searchParams.get('to');

        if (toParam) {
            // The 'to' parameter is ROT13 encoded, decode it
            const toRot13 = decodeRot13(toParam);
            console.log(`${label} "to" parameter (ROT13 decoded):`, toRot13);

            // Parse and display parameters in table
            const advertUrl = new URL(toRot13);
            const params = {};
            advertUrl.searchParams.forEach((value, key) => {
                params[key] = value;
            });
            console.table(params);
        }
    } catch (e) {
        console.error(`Failed to decode ${label} URL:`, e);
    }
}
